import { render, staticRenderFns } from "./DashboardEmpty.vue?vue&type=template&id=4b089921"
import script from "./DashboardEmpty.vue?vue&type=script&lang=js"
export * from "./DashboardEmpty.vue?vue&type=script&lang=js"
import style0 from "./DashboardEmpty.vue?vue&type=style&index=0&id=4b089921&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports